export default {
    languages: state => state.languages,
    getConfig: state => state
}
